import { API, axiosInstance } from "lib";

export const createInvoiceBillRaise = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_INVOICE_BILL_RAISE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getInvoiceBillRaiseListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_INVOICE_BILL_RAISE_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getDetailsInvoiceBillRaise = (data = {}) => {
  return axiosInstance
    .post(API.GET_DETAILS_INVOICE_BILL_RAISE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getDetailsOfSummaryData = (data = {}) => {
  return axiosInstance
    .post(API.GET_SUMMARY_DETAILS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getInvoiceBillRaiseSummaryData = (data = {}) => {
  return axiosInstance
    .post(API.GET_INVOICE_BILL_RAISE_SUMMARY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getInvoiceBillRaiseDataOfLr = (data = {}) => {
  return axiosInstance
    .post(API.GET_LR_FOR_INVOICE_BILL_RAISE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const createInvoiceBillTemplate = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_INVOICE_BILL_RAISE_TEMPLATE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateInvoiceBillRaiseDataOfLr = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_LR_INVOICE_BILL_RAISE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const resetColumnInvoiceBillRaise = (data = {}) => {
  return axiosInstance
    .post(API.RESET_LR_INVOICE_BILL_RAISE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// invoice details add payment , add tds , add claims apis,

export const createPaymentInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_ADD_PAYMENT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const createTdsInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_ADD_TDS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const addClaimPartyInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_ADD_CLAIM, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getLrForSelectLrInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_SELECT_LR_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// select claims

export const getListDataForSelectClaims = (data = {}) => {
  return axiosInstance
    .post(API.BILL_RAISE_SELECT_CLAIMS_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// claim list data for invoice details tabs

export const getClaimListForInoviceDetailsTab = (data = {}) => {
  return axiosInstance
    .post(API.GET_CLAIM_LIST_FOR_INVOICE_DETAILS_TAB, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getPdfInvoiceBillRaise = (data = {}) => {
  return axiosInstance
    .get(API.GET_PDF_LR_BILL_RAISE + `/${data?.company_id}/${data?.billraise_id}/${data?.formatId}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getPdfInvoiceBillRaise2 = (data = {}) => {
  return axiosInstance
    .get(API.DOWNLOAD_PDF, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// 
export const lrDeleteForSummaryDetails = (data = {}) => {
  return axiosInstance
    .post(API.LR_DELETE_FROM_SUMMARY_DETAILS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// claim details transaction delete

export const claimDeleteForSummaryDetails = (data = {}) => {
  return axiosInstance
    .post(API.CLAIM_DELETE_FROM_SUMMARY_DETAILS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// details transaction delete

export const transactionDeleteForSummaryDetails = (data = {}) => {
  return axiosInstance
    .post(API.TRANSACTION_DELETE_FROM_SUMMARY_DETAILS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// get branch get_billraise_number 

export const getBillRaiseNumber = (data = {}) => {
  return axiosInstance
    .post(API.BILL_RAISE_SERIES, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// invoice table changes 

export const getPendingLrList = (data = {}) => {
  return axiosInstance
    .post(API.GET_PENDING_LR_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getPendingClaimList = (data = {}) => {
  return axiosInstance
    .post(API.GET_PENDING_CLAIM_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const addPaymentLrToLrInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_ADD_PAYMENT_LR_TO_LR, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const addTdsPercentageLrToLrInvoiceDetails = (data = {}) => {
  return axiosInstance
    .post(API.INVOICE_DETAILS_ADD_TDS_LR_TO_LR, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

// invoice details report

export const getInvoiceReport = (data = {}) => {
  return axiosInstance
    .get(
      `${API.INVOICE_REPORT_VIEW_API}?company_id=${data?.company_id}&billraise_id=${data?.billraise_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error?.response?.data
    });
};